/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceSim = createReactComponent("device-sim", "IconDeviceSim", [
  [
    "path",
    {
      d: "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 11h3v6", key: "svg-1" }],
  ["path", { d: "M15 17v.01", key: "svg-2" }],
  ["path", { d: "M15 14v.01", key: "svg-3" }],
  ["path", { d: "M15 11v.01", key: "svg-4" }],
  ["path", { d: "M9 14v.01", key: "svg-5" }],
  ["path", { d: "M9 17v.01", key: "svg-6" }]
]);

export { IconDeviceSim as default };
//# sourceMappingURL=IconDeviceSim.js.map
